import { graphql } from "gql.tada";
import { CALCULATION_DETAIL_FRAGMENT } from "./queries";

export const SAVE_INPUTS_AND_EXECUTE = graphql(
  `
    mutation SaveInputsAndExecute($input: SaveInputsAndExecuteInput!) {
      saveInputsAndExecute(input: $input) {
        ...CalculationDetail
      }
    }
  `,
  [CALCULATION_DETAIL_FRAGMENT],
);

export const EDIT_CALCULATION_DETAILS = graphql(
  `
    mutation EditCalculationDetails($input: EditCalculationDetailsInput!) {
      editCalculationDetails(input: $input) {
        ...CalculationDetail
      }
    }
  `,
  [CALCULATION_DETAIL_FRAGMENT],
);

export const UPDATE_FORMULA = graphql(
  `
    mutation UpdateFormula($input: UpdateFormulaInput!) {
      updateFormula(input: $input) {
        ...CalculationDetail
      }
    }
  `,
  [CALCULATION_DETAIL_FRAGMENT],
);

export const UPDATE_DIMENSION_VALUE_SUBSET = graphql(
  `
    mutation UpdateDimensionValueSubset(
      $input: UpdateDimensionValueSubsetInput!
    ) {
      updateDimensionValueSubset(input: $input) {
        ...CalculationDetail
      }
    }
  `,
  [CALCULATION_DETAIL_FRAGMENT],
);

export const MARK_CALCULATION_COMPLETE = graphql(
  `
    mutation MarkCalculationComplete($id: ID!, $expectedVersion: Int!) {
      markCalculationComplete(id: $id, expectedVersion: $expectedVersion) {
        ...CalculationDetail
      }
    }
  `,
  [CALCULATION_DETAIL_FRAGMENT],
);

export const RECALCULATE_CALCULATION = graphql(
  `
    mutation RecalculateCalculation($id: ID!, $expectedVersion: Int!) {
      recalculateCalculation(id: $id, expectedVersion: $expectedVersion) {
        ...CalculationDetail
      }
    }
  `,
  [CALCULATION_DETAIL_FRAGMENT],
);

export const REOPEN_CALCULATION = graphql(
  `
    mutation ReopenCalculation($id: ID!, $expectedVersion: Int!) {
      reopenCalculation(id: $id, expectedVersion: $expectedVersion) {
        ...CalculationDetail
      }
    }
  `,
  [CALCULATION_DETAIL_FRAGMENT],
);
